import { Stack, Typography } from '@mui/material'
import { X } from 'lucide-react'

import { EditIcon } from '@/assets/icons/edit-icon'
import { useBulkImportStore } from '@/components/BulkImportModal/hooks/useBulkImportStore'

export function HeaderBulkImportEditModal({ onClose }: { onClose: () => void }) {
  const bulkType = useBulkImportStore(store => store.modalBulkType)
  const selectedCards = useBulkImportStore(store => store.selectedCards)

  const isBulkEdit = bulkType === 'bulk_edit'

  const isAddImages = bulkType === 'add_images'
  const isGenerateTranslations = bulkType === 'generate_translations'
  const isGenerateOptions = bulkType === 'generate_options'
  const isGenerateCorrectAnswers = bulkType === 'generate_correct_answers'
  const isGradingMethod = bulkType === 'select_grading_method'

  return (
    <Stack
      sx={{
        padding: '24px',
        flexDirection: 'row',
        justifyContent: 'space-between',
      }}
    >
      {isGradingMethod ? (
        <Stack>
          <Typography fontSize={16} fontWeight="semibold">
            Grading Method
          </Typography>
          <Typography color="#475467">How should student responses be graded?</Typography>
        </Stack>
      ) : null}

      {isGenerateOptions ? (
        <Stack>
          <Typography fontSize={16} fontWeight="semibold">
            Generate Answer Options
          </Typography>
          <Typography color="#475467">
            Let AI create multiple-choice options based on your question. You can always review and edit them later. s
          </Typography>
        </Stack>
      ) : null}

      {isGenerateCorrectAnswers ? (
        <Stack>
          <Typography fontSize={16} fontWeight="semibold">
            Generate Correct Answers
          </Typography>
          <Typography color="#475467">
            Let AI generate correct answers for your short answer questions based on the prompts. You can always review and edit them later.
          </Typography>
        </Stack>
      ) : null}

      {isGenerateTranslations ? (
        <Stack>
          <Typography fontSize={16} fontWeight="semibold">
            Generate Translations
          </Typography>
          <Typography color="#475467">Translate your target terms into one or more languages using AI.</Typography>
        </Stack>
      ) : null}

      {isBulkEdit ? (
        <Stack
          sx={{
            flexDirection: 'row',
            alignItems: 'center',
            gap: '16px',
          }}
        >
          <Stack
            sx={{
              padding: '12px',
              borderRadius: '10px',
              border: '1px solid #E0E0E0',
            }}
          >
            <EditIcon />
          </Stack>
          <Stack>
            <Typography fontSize={16} fontWeight="semibold">
              Bulk Edit:
            </Typography>
            <Typography color="#475467">{selectedCards.length} Rows Selected</Typography>
          </Stack>
        </Stack>
      ) : null}

      {isAddImages ? (
        <Stack>
          <Typography fontSize={16} fontWeight="semibold">
            Add Images
          </Typography>
          <Typography color="#475467">Add images to your cards. You can always review and edit them later.</Typography>
        </Stack>
      ) : null}

      <X color="#98A2B3" onClick={onClose} />
    </Stack>
  )
}
